import { Document, Page, Text, View, StyleSheet, Image, Font, Link } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NotoSansRegular from '../fonts/NotoSans-Regular.ttf';
import NotoArabicSans from '../fonts/NotoSansArabic-Regular.ttf';
import ArialMS from '../fonts/Arial-Unicode-MS-Regular.ttf';

Font.registerEmojiSource({
    format: 'png',
    url: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/",
});

Font.register({ family: "NotoSans", src: NotoSansRegular });
Font.register({ family: "NotoSansArabic", src: NotoArabicSans });
Font.register({ family: "ArialMS", src: ArialMS });

const styles = StyleSheet.create({
    page: {
        padding: 20,
    },
    message: {
        fontSize: 12,
        paddingVertical: 5,
        lineHeight: 1.4,
    },
    icon: {
        width: 12,
        height: 12,
        marginLeft: 10,
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 20
    },
    logo: {
        width: '100pt',
        height: '100pt',
        objectFit: 'contain',
    },
    moreInfoContainer: {
        // marginTop: 20,
        paddingHorizontal: 40,
        paddingVertical: 10,
        // borderColor: '#912d2a',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 5,
        maxWidth: '70%',
        margin: 'auto',
        marginBottom: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '75px'
    },
    moreInfoText: {
        fontSize: 9,
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: 5,
    },
    siteLink: {
        fontSize: 11,
        textAlign: 'center',
        fontWeight: 'heavy',
        textDecoration: 'underline',
        color: 'black'
    },
    date: {
        fontSize: 10,
        textAlign: 'center',
        marginBottom: 30,
    },
    chatIdContainer: {
        marginBottom: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chatIdText: {
        fontSize: 10,
        textAlign: 'center',
    }
})

const ChatPDF = ({ message, dateInfo, primary, domain, image, botId, voiceMode, publicMode, bot, chatId }) => {

    const { t, i18n } = useTranslation();

    const url = `http://${domain}/${publicMode ? `?bot=${botId}&voiceMode=${voiceMode}` : domain.includes('creator') ? `agents/${bot.slug}/?id=${bot.id}` : ''}`;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.imageContainer}>
                    <Image src={image} style={styles.logo} />
                </View>
                <View style={styles.chatIdContainer}>
                    <Text style={[styles.chatIdText, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}>{t('Chat ID')}: {chatId}</Text>
                </View>
                <Text style={[styles.message, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}>{message}</Text>
                <View style={[styles.moreInfoContainer, { borderColor: primary }]}>
                    <Text style={[styles.moreInfoText, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' } ]}>{t('check out more info here:')}</Text>
                    <Link src={url} style={[styles.siteLink, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}><Text>{`https://${domain}`}</Text></Link>
                </View>
                <Text style={[styles.date, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}>{dateInfo}</Text>
            </Page>
        </Document>
    )
}


export default ChatPDF;